<template>
  <div>
    <Container class="container-sm-none">
      <Progressbar :step="childrenWithIndexes.length > 0 ? 12 : 9" :step-count="model.stepCount">
        Summary
      </Progressbar>
      <Card class="card-shadow">
        <div class="width-lg">
          <div class="pl-10 pl-md-0 pr-10 pr-md-0">
            <h3 class="weight-medium pb-10 pb-md-15 text-left text-md-center">
              Check the Entered Details
            </h3>

            <SummarizationCard title='Contact Details' class="smc-no-border">
              <SummarizationItem>
                <template v-slot:title>
                  Phone Number
                </template>
                <p class="m-0">
                  {{ model.insurer.phone }}
                </p>
              </SummarizationItem>
              <SummarizationItem>
                <template v-slot:title>
                  E-mail
                </template>
                <p class="m-0">
                  {{ model.insurer.email }}
                </p>
              </SummarizationItem>
            </SummarizationCard>

            <Collapse
              v-for="(person, index) in model.insuredPersons.array_hd7ov6$_0"
              :key="'person' + index + 1"
              :opened="true"
              :index="index"
              :model="model"
              :person-count="model.insuredPersons.array_hd7ov6$_0.length"
              :disableRemove="true"
            >
              <template v-slot:title>
                <p v-if="person.name && person.surname">
                  {{`${person.name} ${person.surname}`}}
                </p>
                <p v-else>
                  Policyholder {{`${index + 1}`}}
                </p>
              </template>
              <AdultSummarization
                v-if="person.isAdult"
                :person="person"
                :model="model"
                :errors="errors"
                :key="index"/>
              <ChildSummarization
                v-else
                :person="person"
                :model="model"
                :errors="errors"
                :key="index"
              />
            </Collapse>

          <div class="text-left mt-md-20 p-10 bg-gray-200">
            <h4 class="weight-medium line-24">
              Consent to the processing of Personal Data for Marketing Purposes
            </h4>
            <p class="body-2 mt-8 weight-regular line-24">
              You give consent to receive news and useful information about benefits, bonuses, discounts, products and services.
            </p>
            <div v-for="(person, index) in model.insuredPersons.array_hd7ov6$_0" :key="person.birthNumber">
              <p class="body-1 mt-8 mb-8 weight-regular">
                {{ `${person.name} ${person.surname}` }}
              </p>
              <div class="flex gap-15">
                <BooleanRadioButton
                  class="body-3 weight-regular"
                  title='Yes'
                  :name="'marketingAgreement' + index"
                  :option="true"
                  v-model="person.marketingAgreement"
                />
                <BooleanRadioButton
                  class="body-3 weight-regular"
                  title='No'
                  :name="'marketingAgreement' + index"
                  :option="false"
                  v-model="person.marketingAgreement"
                />
              </div>
            </div>
            <p class="body-2 mt-8 weight-regular line-24">
              
    By giving this consent, you agree that your personal data in the scope of name, surname, title,
    permanent residence address, mailing address, phone number and e-mail will be processed by
    Union zdravotná poisťovňa, a.s, Union poisťovňa, a. s. and their subsidiaries, if any;
    for the purpose of marketing activities (the aforementioned companies are joint controllers
    when processing personal data for marketing purposes). At the same time, you consent
    to the use of your phone number and e-mail to receive marketing messages via e-mail or SMS.
    Consent is given for the duration of the public health insurance policy and for a period of
    5 years after its termination. The provision of personal data for the above purposes is optional.
    This consent may be revoked in writing at any time, without retroactive effect.
  
            </p>
            <p class="body-2 mt-8 weight-regular">
              Information on personal data protection
              <a
                class="color-black"
                href="https://www.union.sk/ochrana-osobnych-udajov"
                target="_blank"
              >
                can be viewed here
              </a>.
            </p>
          </div>

          <div class="pl-10 pl-md-0 pr-10 pr-md-0">
            <ButtonGroup class="pt-21">
              <Button
                class="btn-outline-tertiary w-full"
                :icon-left="require('@/assets/svg/icon-left-gray.svg')"
                @click="redirectBack"
              >
                Back
              </Button>
              <Button
                class="btn-primary w-full"
                :icon-right="require('@/assets/svg/icon-right-white.svg')"
                @click="redirectToNext"
              >
                Continue
              </Button>
            </ButtonGroup>
          </div>
        </div>
        </div>
      </Card>
    </Container>
  </div>
</template>
<script>
import Container from '@/components/Container/Container.vue';
import Progressbar from '@/components/Progressbar/Progressbar.vue';
import Card from '@/components/Card/Card.vue';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import Button from '@/components/Button/Button.vue';
import AdultSummarization from '@/pagesComponents/AdultSummarization.vue';
import routes from '@/mixins/routes';
import enums from '@/mixins/enums';
import BooleanRadioButton from '@/components/BooleanRadioButton/RadioButton.vue';
import ChildSummarization from '@/pagesComponents/ChildSummarization.vue';
import SummarizationCard from '@/components/SummarizationCard/SummarizationCard.vue';
import SummarizationItem from '@/components/SummarizationItem/SummarizationItem.vue';
import lead from '@/mixins/lead';
import Collapse from '@/components/Collapse/Collapse.vue';
import GA from '@/mixins/GA';

export default {
  name: 'SummaryPage',
  components: {
    Collapse,
    SummarizationItem,
    SummarizationCard,
    BooleanRadioButton,
    AdultSummarization,
    ChildSummarization,
    Button,
    ButtonGroup,
    Card,
    Progressbar,
    Container,
  },
  mixins: [routes, enums, lead, GA],
  props: {
    errors: { type: Array, required: true },
    model: { type: Object, required: true },
  },
  methods: {
    redirectToNext() {
      if (this.errors.length === 0) {
        this.saveLead(this.getNearestNextAvailableStep());
        if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(this.getNearestNextAvailableStep())) {
          this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(this.getNearestNextAvailableStep());
        }
        this.model.currentPersonStepIndex += 1;
        this.$router.goToStep(this.getNearestNextAvailableStep());
      }
    },
    redirectBack() {
      this.$router.goToStep(this.getNearestPreviousAvailableStep());
    },
  },
  created() {
    this.model.step = 18;
    if (this.model.lastStep < 18) this.model.lastStep = 18;
  },
  mounted() {
    this.funnelStep('Zhrnutie');
    this.children.forEach((child) => {
      const adultIndex = child.firstLegalRepresentative.personIndex;
      const adult = this.model.insuredPersons.array_hd7ov6$_0[adultIndex];
      Object.keys(child.firstLegalRepresentative).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(adult, key) && adult[key] !== '') {
          child.firstLegalRepresentative[key] = adult[key];
        }
      });
    });
  },
};
</script>
